import RespWeb from './resp_web';

const MapMenu = {
	toggle: () => {
		const menuButton = document.querySelector('.map-mobile-menu-button-bar');
		const mapMenu = document.querySelector('.map-menu');
		const menuCollapase = document.querySelector('.menu-collapse');

		mapMenu.classList.toggle('collapsed');
		menuCollapase.classList.toggle('opened');

		if (menuButton.getAttribute('aria-expanded') === 'false') {
			menuButton.setAttribute('aria-expanded', true);
		} else {
			menuButton.setAttribute('aria-expanded', false);
		}
		if (menuCollapase.getAttribute('aria-hidden') === 'false') {
			menuCollapase.setAttribute('aria-hidden', true);
		} else {
			menuCollapase.setAttribute('aria-hidden', false);
		}
	},

	hide: () => {
		if (RespWeb.desktop()) {
			return false;
		}

		const menuButton = document.querySelector('.map-mobile-menu-button-bar');
		const mapMenu = document.querySelector('.map-menu');
		const menuCollapase = document.querySelector('.menu-collapse');

		mapMenu.classList.add('collapsed');
		menuCollapase.classList.remove('opened');
		menuButton.setAttribute('aria-expanded', false);
		menuCollapase.setAttribute('aria-hidden', true);
	},

	toggleLayer: (e) => {
		const checkbox = e.target;
		const active = checkbox.checked;
		const layer_key = checkbox.dataset.mapLayer;
		const layer = W.layers[layer_key];

		// Register a google analytics event for the layer
		if (typeof gtag !== 'undefined') {
			gtag('event', active ? 'enable-layer' : 'disable-layer', {
				event_category: 'Layers',
				event_label: layer_key,
			});
		}

		if (layer) {
			active ? layer.add(W.map) : layer.remove();
		}
	},

	addListeners: () => {
		// mobile menu button
		const menuButton = document.querySelector('.map-mobile-menu-button-bar');
		if (!menuButton) return;
		menuButton.addEventListener('click', MapMenu.toggle);

		// map layers
		document.querySelectorAll('input[type="checkbox"][data-map-layer]').forEach((layer_checkbox) => {
			layer_checkbox.addEventListener('change', MapMenu.toggleLayer);
		});
	},
};

MapMenu.addListeners();

export default MapMenu;
